import * as THREE from 'three'

export const translateObj = (obj, degree, translateVec) => {
  obj.translateX(translateVec.x)
  obj.translateY(translateVec.y)
  obj.rotateOnAxis(new THREE.Vector3(0, 0, 1), (degree * Math.PI) / 180)
  obj.translateX(-translateVec.x)
  obj.translateY(-translateVec.y)
}
